module.exports = [
  ...require('./vue2-builtin-components'),
  'teleport',
  'Teleport',
  'suspense',
  'Suspense'
]
